import Services from './base-services'
import mapParameters from '../utils/map-parameters'

const service = new Services('avatar-pack')

export default {
    getAvatarPackByName: (name: string) => {
        return service.get(`getAvatarPackByName?name=${name}`)
    },
    getAll: () => {
        return service.get(`getAll`)
    },
    getPage(number: number, size?: number) {
        const params = mapParameters({
            number: number ? number : 0,
            size: size ? size : 15
        })
        return service.get('getPage', params)
    }
}
